import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, effect
  , EventEmitter, inject, input, linkedSignal, OnDestroy, OnInit, Output,
  signal
} from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { MatInputModule } from '@angular/material/input';
import { RouterOutlet } from '@angular/router';
import { FuseAlertComponent } from '@fuse/components/alert';
import { ItmToolbarComponent } from '@itm/components/toolbar';
import { 
  GridModule, SearchService, ToolbarService, ExcelExportService, PdfExportService
  , FilterService, SortService, GroupService, PageService
  , ColumnChooserService, ColumnMenuService, ReorderService, ResizeService
} from '@syncfusion/ej2-angular-grids';
import { AlertSidebarComponent } from './alert/alert-sidebar.component';
import { ApplyEasySidebarComponent } from './applyeasy/applyeasy-sidebar.component';
import { ActionPOSubType, ActionPRSubType, ActionType } from '../../utilities';
import { filter, map, Subject, takeUntil } from 'rxjs';
import { CacActionService } from '../../cac.action.service';
import { ItmToastrService } from '@itm/services';
import { PurchaseRequisitionSidebarComponent } from './purchase-requisition/purchase-requisition-sidebar.component';
import { SupplierSidebarComponent } from './supplier/supplier-sidebar.component';
import { SubHirePurchaseRequisitionSidebarComponent } from './sub-hire-purchase-requisition/sub-hire-purchase-requisition-sidebar.component';
import { AuditDetailComponent } from '@itm/components/audit-detail/audit-detail.component';

@Component({
    selector: 'sidebar-manager',
    templateUrl: './sidebar-manager.component.html',
    styleUrls: ['./sidebar-manager.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      // RouterOutlet,
      CommonModule
      , GridModule
      // , ItmToolbarComponent
      // , FuseAlertComponent
      , MatInputModule
      , AlertSidebarComponent
      , PurchaseRequisitionSidebarComponent
      , SupplierSidebarComponent
      // , SubHirePurchaseRequisitionSidebarComponent
      , ApplyEasySidebarComponent
      , AuditDetailComponent ],
    providers: [SearchService,
      ToolbarService,
      ExcelExportService,
      PdfExportService,
      FilterService,
      SortService,
      GroupService,
      PageService,
      ColumnChooserService,
      ColumnMenuService,
      ReorderService,
      ResizeService
    ],
})
export class SideBarManagerComponent implements OnInit, OnDestroy {

  private readonly _cacService = inject(CacActionService);
  private readonly _toastr = inject(ItmToastrService);
  private readonly _changeDetectorRef = inject(ChangeDetectorRef);
  
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  
  @Output() firePopupCloseEvent = new EventEmitter();

  ActionType = ActionType;
  ActionPRSubType = ActionPRSubType;
  ActionPOSubType = ActionPOSubType;
  title: any = '';

  actionData = input<any>();

  actionDataSig = linkedSignal<any>(() => this.actionData());
  // localActionData = computed(() => {
  //   return this.actionDataSig()
  // });
  inProgress = linkedSignal<any>(() => false);

  openingAudit = input<any>();

  actionData$ = toObservable(this.actionData);

  constructor() {
    effect(() => {
      // console.log(this.actionDataSig())
      // console.log(this.localActionData())
    })
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  closeClick(){
    this.firePopupCloseEvent.emit();
  }

  onRemindHourClick(e: any){
    this._cacService.remind([this.actionData()?.id]).subscribe((resp: any) => {
      if(resp.data.result > 0){
        this.firePopupCloseEvent.emit();
        this._toastr.showSuccess('Successfully applied reminder.');
      }
    })
  }

  onDoNotEscalateClick(e: any){
    const data = [{
      'id': this.actionData()?.id,
      'reason': e.data.reason
    }];
    this._cacService.doNotEscalate(data).subscribe((resp: any) => {
      if(resp.data.result > 0){
        this.firePopupCloseEvent.emit();
        this._toastr.showSuccess('Successfully applied do not escalate.');
      }
    })
  }
  
  // onResolveClick(e: any){
  //   const data = [{
  //     'id': this.actionData()?.id,
  //     'reason': e.data.reason
  //   }];
  //   this._cacService.doResolve(data).subscribe((resp: any) => {
  //     if(resp.data.result == true){
  //       this.firePopupCloseEvent.emit();
  //       this._toastr.showSuccess('Successfully resolved.');
  //     }
  //   })
  // }

  onResolveClick(e: any){
    const data = [{
      'id': this.actionData()?.id,
      'reason': e.data.reason
    }];
    this._cacService.doResolve(data).subscribe((resp: any) => {
      console.log(resp)
      if(resp.data.result >=0){
        this.firePopupCloseEvent.emit();
        this._toastr.showSuccess('Successfully resolved.');
      }
    })
  }

  onRejectClick(e: any){
    // console.log('onRejectClick', this.actionData())
    // return;
    this.inProgress.set(true);
    this._cacService.rejectPR(e.apiUrl, this.actionData()).subscribe((resp: any) => {
    this.inProgress.set(false);
      if(resp?.data?.result == true){
        this.firePopupCloseEvent.emit();
        this._toastr.showSuccess('Successfully rejected.');
      }
    })
  }

  onApproveClick(e: any) {
    // console.log('onApproveClick', e, this.actionData())
    // return;
    this.inProgress.set(true);
    this._cacService.approvePR(e.apiUrl, this.actionData()).subscribe((resp: any) => {
      this.inProgress.set(false);
      if(resp?.data?.result == true){
        this.firePopupCloseEvent.emit();
        this._toastr.showSuccess('Successfully approved.');
      }
    })
  }

  onResolveWithCustomerClick() {
    this.firePopupCloseEvent.emit();
  }

  onRequestInfoClick(e: any) {
    // console.log('onRequestInfoClick', e, this.actionData())
    // const body = {
    //   chats: e.data,
    //   actionDto: this.actionData(),
    //   actionType: 'request_line_items'
    // }

    // console.log(body)
    // return;
    this.inProgress.set(true);
    this._cacService.sendMessage(this.actionData().id, e.formData).subscribe((resp: any) => {
    this.inProgress.set(false);
      // console.log(resp)
      const { data } = resp;
      if(data?.result?.chats){
        // this.firePopupCloseEvent.emit();
        this.actionDataSig.update(prev  => ({
          ...prev,
          chats: data.result.chats
        }));
        this._toastr.showSuccess('Comment sent successfully.');
      }
    })
  }
}
